module.exports = new __parcel__URL__("virtual-agent-virtual-agent-statistics-app-skeleton.tpl.19ee5056.svg").toString();